import React from 'react';
import styled, { css } from 'styled-components';
import { colors } from 'bench-style-constants';

import { spinnerDash, spinnerRotate } from './keyframes';

const offset = 186;

const SpinnerContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const animationRule = css`
  ${spinnerRotate} 1.5s linear infinite;
`;

const animationRuleCircle = css`
  ${spinnerDash(offset)} 1.5s ease-in-out infinite;
`;

const SpinnerWrapper = styled.div`
  width: 40px;
  height: 40px;

  svg {
    width: 40px;
    height: 40px;

    animation: ${animationRule};
    transition: none;

    circle {
      stroke-dasharray: ${offset};
      stroke-dashoffset: 0;
      transform-origin: center;
      stroke: ${colors.water};
      animation: ${animationRuleCircle};
    }
  }
`;

export const Spinner = () => (
  <SpinnerWrapper>
    <svg
      aria-labelledby="loadingSpinner"
      aria-busy="true"
      width="40px"
      height="40px"
      viewBox="0 0 66 66"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title id="loadingSpinner">Loading Spinner</title>
      <circle fill="none" strokeWidth="6" strokeLinecap="round" cx="33" cy="33" r="30" />
    </svg>
  </SpinnerWrapper>
);

const LoadingSpinner = () => (
  <SpinnerContainer>
    <Spinner />
  </SpinnerContainer>
);

export default LoadingSpinner;
